export default {
  data: null,
};
